import { render, staticRenderFns } from "./fanstore.vue?vue&type=template&id=05b51bb5&"
import script from "./fanstore.vue?vue&type=script&lang=js&"
export * from "./fanstore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports